export const Authorization = 'Authorization';
export const Token = 'token';
export const UserInfo = 'userInfo';
export enum UserRole {
  ADMIN = 'ADMIN',
  CREATOR = 'CREATOR',
  NORMAL = 'NORMAL',
}
export enum AccessType {
  USER = 'USER',
  GROUP = 'GROUP',
}
export enum Visibility {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}
